import { selectAllFires, selectFireById } from "features/entity-caching/fires/selectors"
import { getProjectFilterOptionById } from "features/overview/filters/projectFilterOptions"
import { useAppSelector } from "integrations/redux/hooks"
import store from "integrations/redux/store"
import { isDefined } from "nodash"
import { useCallback } from "react"
import { z } from "zod"
import {
    ProjectFullPanelHeader,
    ProjectFullPanelResult,
    ProjectSearchResult,
} from "../../searchResults/ProjectSearchResult"
import { defineActivatablePlugin } from "../types"
import { selectProjectFilter } from "features/overview/slice"

const projectSearchResultDataSchema = z.object({
    projectId: z.string(),
})

export const projectsPlugin = defineActivatablePlugin({
    name: "projects",
    displayName: "Projects",
    useSearch: () => {
        const projectFilterId = useAppSelector(selectProjectFilter)
        const projectFilter = getProjectFilterOptionById(projectFilterId)
        const allProjects = useAppSelector(selectAllFires)
        return useCallback(
            async (query) => {
                const q = query.toLowerCase()
                return Object.values(allProjects)
                    .filter(isDefined)
                    .filter((project) => project.name.toLowerCase().includes(q))
                    .filter(projectFilter.filter)
                    .map((project) => ({ projectId: project.id }))
            },
            [projectFilter.filter, allProjects]
        )
    },
    dataSchema: projectSearchResultDataSchema,
    Component: ProjectSearchResult,
    FullPanelHeaderComponent: ProjectFullPanelHeader,
    FullPanelResultComponent: ProjectFullPanelResult,
    getKey: (data) => data.projectId,
    getSearchableText: (data) => selectFireById(data.projectId)(store.getState())?.name ?? "",
})
